export default __webpack_public_path__ + "static/media/ic-calendar.1d230791.png";